import { fetchAllTagData } from './routines';

export const fetchTags = (error) => ({
    type: fetchAllTagData.TRIGGER,
    error,
});
